var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _circle3, _circle4, _circle5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _circle6, _circle7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkValidityScoreNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 165.366,
    y: 158.414,
    width: 57.4554,
    height: 88.058,
    rx: 28.7277,
    transform: "rotate(46.2508 165.366 158.414)",
    stroke: "#192657",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 165.918,
    y: 166.159,
    width: 45.5644,
    height: 78.2601,
    rx: 22.7822,
    transform: "rotate(46.2508 165.918 166.159)",
    stroke: "#192657",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 232.776,
    y: 85.6107,
    width: 57.4554,
    height: 86.86,
    rx: 28.7277,
    transform: "rotate(46.2508 232.776 85.6107)",
    stroke: "#192657",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 233.375,
    y: 93.3094,
    width: 45.5644,
    height: 77.1925,
    rx: 22.7822,
    transform: "rotate(46.2508 233.375 93.3094)",
    stroke: "#192657",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 203.298,
    y: 148.828,
    width: 11.1964,
    height: 54,
    rx: 5.59821,
    transform: "rotate(43.9406 203.298 148.828)",
    fill: "#F58120",
    stroke: "#ECEFF3",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297.5 171C297.5 232.58 247.58 282.5 186 282.5C124.42 282.5 74.5 232.58 74.5 171C74.5 109.42 124.42 59.5 186 59.5C247.58 59.5 297.5 109.42 297.5 171Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186 282C124.144 282 74 231.856 74 170",
    stroke: "#192657",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186 59C247.856 59 298 109.144 298 171",
    stroke: "#192657",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74 171C74 109.144 124.144 59 186 59",
    stroke: "#528FF5",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M182.1 51L188.543 60.0404L182 66.9997",
    stroke: "#528FF5",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M297.6 171C297.6 232.856 247.456 283 185.6 283",
    stroke: "#F58120",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.5 291L183.056 281.96L189.6 275",
    stroke: "#F58120",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 317.5,
    cy: 188.5,
    r: 7.5,
    fill: "#528FF5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.5,
    cy: 208.5,
    r: 7.5,
    fill: "#528FF5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.5,
    cy: 228.5,
    r: 7.5,
    fill: "#528FF5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.5,
    cy: 248.5,
    r: 7.5,
    fill: "#528FF5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.5,
    cy: 268.5,
    r: 7.5,
    fill: "#528FF5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 51,
    width: 47,
    height: 4,
    fill: "#F58120"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 61,
    width: 47,
    height: 4,
    fill: "#F58120"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 71,
    width: 47,
    height: 4,
    fill: "#F58120"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 105.048,
    width: 20,
    height: 1.90476,
    rx: 0.952381,
    fill: "#192657"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 134.953,
    y: 96,
    width: 20,
    height: 1.90476,
    rx: 0.952381,
    transform: "rotate(90 134.953 96)",
    fill: "#192657"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 125.048,
    width: 20,
    height: 1.90476,
    rx: 0.952381,
    fill: "#192657"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 124.953,
    y: 116,
    width: 20,
    height: 1.90476,
    rx: 0.952381,
    transform: "rotate(90 124.953 116)",
    fill: "#192657"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 241.5,
    r: 19.5,
    stroke: "#F58120",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 255,
    r: 13,
    stroke: "#528FF5",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M286.496 178.584C286.543 178.033 286.134 177.55 285.584 177.504C285.033 177.457 284.55 177.866 284.504 178.416L286.496 178.584ZM203.059 267.998C216.062 267.233 235.64 259.876 252.591 245.257C269.57 230.613 283.971 208.633 286.496 178.584L284.504 178.416C282.029 207.867 267.93 229.387 251.284 243.743C234.61 258.124 215.438 265.267 202.941 266.002L203.059 267.998Z",
    fill: "#192657"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M234 250C227.167 254.833 205.8 264.5 175 264.5",
    stroke: "#192657",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M307.499 68.0001C203.666 30.0001 6.39932 -15.8999 47.9993 104.5C99.9993 255 248.499 42 307.499 128.5C366.499 215 150.999 412 60.9993 292C-29.0007 172 52.4993 -4.49983 173.499 104.5",
    stroke: "black",
    strokeDasharray: "2 2 2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkValidityScoreNew);
export default __webpack_public_path__ + "static/media/LinkValidityScoreNew.cd24ee8715072760bf046a478f0a3e79.svg";
export { ForwardRef as ReactComponent };